import axios from "axios";
import apiConfig from "config/api";
import tokenService from "services/auth/tokenService";

const axiosClient = axios.create({
    baseURL: apiConfig.baseUrl, // process.env.REACT_APP_API_URL,
    headers: {
        "Content-Type": "application/json"
    },
    timeout: apiConfig.timeout
});

axiosClient.interceptors.request.use(
    (config) => {
        const token = tokenService.getToken();

        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }

        return config;
    },
    (error) => Promise.reject(error)
);

axiosClient.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            tokenService.clear();

            window.location.href = "/login";
        }

        return Promise.reject(error);
    }
);

export default axiosClient;
